
export default {
    init() {
        $('.zoom').zoom({
            url: $(this).attr('href'),
        });
    },
    finalize() {
        // scripts here fire after init() runs
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/work.js